import { apiGet, apiPut } from '../utils/apiClient';

export default class ConfigIntegration {
    getConfig(botApiUrl, templateId, authToken) {
        return apiGet(`${botApiUrl}/bot-templates/${templateId}/config`, { authToken });
    }

    getTemplateName(botApiUrl, templateId, authToken) {
        return apiGet(`${botApiUrl}/bot-templates/${templateId}`, { authToken });
    }

    getIntents(conversationApiUrl, templateId, authToken) {
        return apiGet(`${conversationApiUrl}/nlu/intents/${templateId}`, { authToken })
            .then((data) => (Array.isArray(data) ? data : []))
            .catch(() => [])
            .then((data) =>
                data.map((intent) => ({
                    value: intent.name,
                    label: intent.name,
                }))
            );
    }

    getActions() {
        return apiGet(`${process.env.REACT_APP_JSON_URL}/actions.json`)
            .then((d) => d.root);
    }

    saveConfig(botApiUrl, templateId, configuration, authToken) {
        return apiPut(
            `${botApiUrl}/bot-templates/${templateId}/config`,
            configuration,
            { authToken }
        );
    }
}
